import { useEffect, useState, memo } from "react";

import { Chart } from "primereact/chart";

import ChartDataLabels from 'chartjs-plugin-datalabels';

const GraficoResiduoProduto = memo(function GraficoResiduoProduto({ month, residuos, setor }) {
    const [chartData, setChartData] = useState();

    const chartOptions = {
        maintainAspectRatio: false,
        plugins: {
            datalabels: {
                anchor: 'end',
                align: 'end',
                formatter: (value) => {
                    return Intl.NumberFormat("pt-BR", {
                        maximumFractionDigits: 2,
                    }).format(value);
                },
                font: {
                    size: 14,
                    weight: 'bold',
                },
                color: "#2c3e50"
            },
        },
    }

    const MONTHS = [
        "JANEIRO",
        "FEVEREIRO",
        "MARÇO",
        "ABRIL",
        "MAIO",
        "JUNHO",
        "JULHO",
        "AGOSTO",
        "SETEMBRO",
        "OUTUBRO",
        "NOVEMBRO",
        "DEZEMBRO",
    ];

    useEffect(() => {
        let data = [];

        let filteredData = residuos.filter((element) => {
            return parseInt(element.mes) === month && element.setor === setor && parseFloat(element.soma) > 0; 
        });

        if(filteredData.length === 0) {
            setChartData(null);
            return
        }

        filteredData = filteredData.sort((a, b) => { return parseFloat(a.soma) > parseFloat(b.soma) ? -1 : 1 });
        
        let products = [...new Set(filteredData.map(item => item.descricao))];

        products.forEach((product) => {
            let filteredByProduct = filteredData.find(element => {
                return element.descricao === product;
            });
            data.push(parseFloat(filteredByProduct.soma));
        });
        
        let chartData = {
            labels: products,
            datasets: [
                {
                    backgroundColor: "#1dd1a1",
                    data: data,
                    label: 'Total por Produto (KG)'
                }
            ]
        }

        setChartData(chartData);
    }, [month, residuos, setor]);

    return (
        <div className="p-col-12">
            {chartData !== null && (
                <>
                    <h3 className="text-center text-xl font-semibold text-gray-700 mb-3">
                        {MONTHS[parseInt(month) - 1]}
                    </h3>
                    <Chart
                        data={chartData}
                        height="350px"
                        options={chartOptions}
                        plugins={[ChartDataLabels]}
                        type="bar"
                    />
                </>
            )}
            <hr className="p-mt-6" style={{ border: 0, borderTop: "1px solid #e5e7eb" }}/>
        </div>
    )
});

export default GraficoResiduoProduto